import React, { useEffect, useMemo, useState } from "react";
import "./deeplink.scss";
import { Logo } from "../../../../assets/icons/logo";

const DEFAULT_PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.app.riseupkings";
const DEFAULT_APP_STORE_URL =
  "https://apps.apple.com/us/app/rise-up-kings/id6497878712";

const getDeviceType = () => {
  const ua = navigator.userAgent || navigator.vendor || window.opera;
  const isAndroid = /android/i.test(ua);
  const isIOS =
    /iPad|iPhone|iPod/.test(ua) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

  if (isAndroid) {
    return "android";
  }

  if (isIOS) {
    return "ios";
  }

  return "unknown";
};

export default function Deeplink() {
  const [deviceType, setDeviceType] = useState("checking");

  const playStoreUrl = useMemo(() => {
    return process.env.REACT_APP_RUK_PLAY_STORE_URL || DEFAULT_PLAY_STORE_URL;
  }, []);

  const appStoreUrl = useMemo(() => {
    return process.env.REACT_APP_RUK_APP_STORE_URL || DEFAULT_APP_STORE_URL;
  }, []);

  useEffect(() => {
    const detectedDeviceType = getDeviceType();
    setDeviceType(detectedDeviceType);

    if (detectedDeviceType === "android") {
      window.location.replace(playStoreUrl);
    }

    if (detectedDeviceType === "ios") {
      window.location.replace(appStoreUrl);
    }
  }, [playStoreUrl, appStoreUrl]);

  const isKnownDevice = deviceType === "android" || deviceType === "ios";

  return (
    <div className="deeplink-page">
      <div className="deeplink-card">
        <div className="deeplink-tag deeplink-tag-logo">
          <Logo />
        </div>

        <h1>Rise Up Kings App</h1>

        {deviceType === "checking" && (
          <>
            <h2>Redirecting...</h2>
            <p>Detecting your device and opening the app store.</p>
          </>
        )}

        {deviceType === "unknown" && (
          <>
            <h2>Choose Your Store</h2>
            <p>We could not identify your device. Please continue below.</p>

            <div className="deeplink-actions">
              <a
                href={playStoreUrl}
                className="deeplink-btn deeplink-btn-primary"
                target="_blank"
                rel="noreferrer"
              >
                Open Play Store
              </a>
              <a
                href={appStoreUrl}
                className="deeplink-btn deeplink-btn-secondary"
                target="_blank"
                rel="noreferrer"
              >
                Open App Store
              </a>
            </div>
          </>
        )}

        {isKnownDevice && (
          <>
            <h2>Taking you to the store...</h2>
            <p>If redirection does not work, choose a store below.</p>

            <div className="deeplink-actions">
              <a
                href={playStoreUrl}
                className="deeplink-btn deeplink-btn-primary"
                target="_blank"
                rel="noreferrer"
              >
                Open Play Store
              </a>
              <a
                href={appStoreUrl}
                className="deeplink-btn deeplink-btn-secondary"
                target="_blank"
                rel="noreferrer"
              >
                Open App Store
              </a>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
